import { render, staticRenderFns } from "./PostponedSwiftPaymentReturnOnHoldModal.vue?vue&type=template&id=514ea0fc"
import script from "./PostponedSwiftPaymentReturnOnHoldModal.vue?vue&type=script&lang=js"
export * from "./PostponedSwiftPaymentReturnOnHoldModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports